import React, { useCallback, useState } from 'react';
import Select from 'react-select'

import { createBook } from '../../core/_requests';
import { APIError, useAxios } from '../../core/_axios';
import { PhysicalBook } from '../../core/_models';
import { useNavigate } from 'react-router-dom';
import useServices from '../../hooks/useServices';

export default function ManageBookForm({
    book: book = undefined,
    onSetBook: onSetBook = undefined
}: {
    book?: PhysicalBook,
    onSetBook?: (book: PhysicalBook) => void
}) {
    const axios = useAxios();

    const navigate = useNavigate();

    const {
        services,
        loadingServices,
        errorLoadingServices,
        loadAllServices,
    } = useServices();

    const [savingBook, setSavingBook] = useState(false);
    const [errorSavingBook, setErrorSavingBook] = useState<string | null>(null);
    const [successSavingBook, setSuccessSavingBook] = useState<string | null>(null);

    const [photoOfPersonBlob, setPhotoOfPersonBlob] = useState<Blob | null>(null)

    const onCreateBookFormSubmitted = useCallback(async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (savingBook) {
            return;
        }
        setSuccessSavingBook(null);
        setErrorSavingBook(null);
        setSavingBook(true);
        const form = event.currentTarget;
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        if (!book) {
            try {
                const resultingBook = await createBook(axios, {
                    service_unique_id: data.service_unique_id,
                    create_pdf_for_digital_download: false
                })
                navigate(`/books/${resultingBook.unique_identifier}/details`)
            } catch (exception) {
                console.error(exception)
                const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
                setErrorSavingBook(errorMessage)
                setSavingBook(false)
            }
        } else {
            try {
                throw new Error('Updating books is not currently supported. Please create a new book instead.')
                /*
                const resultingService = await someMethod(axios, book.unique_identifier, {
                    ...data,
                }, photoOfPersonBlob)
                if (!onSetBook) {
                    throw new Error('onSetService is required when updating a service')
                }
                setSuccessSavingBook('Service updated successfully')
                */
                // onSetBook(resultingService)
            } catch (exception) {
                console.error(exception)
                const errorMessage = exception instanceof APIError ? exception.message : 'An unknown error has occurred. Please try again.'
                setErrorSavingBook(errorMessage)
            } finally {
                setSavingBook(false)
            }
        }
    }, [axios, navigate, onSetBook, photoOfPersonBlob, savingBook, book]);

    return <div className="grid grid-cols-1 xl:grid-cols-3 gap-5 lg:gap-7.5">
        <div className="col-span-2">
            {/*<div className="w-full">
                <ActiveServiceBanner
                    viewingService={book}
                />
            </div>*/}
            <div className="flex flex-col gap-5 lg:gap-7.5">
                <form className="card" onSubmit={onCreateBookFormSubmitted}>
                    <div className="card-header">
                        <h3 className="card-title">
                            Select a service for this book
                        </h3>
                    </div>
                    <div className="card-body grid gap-7.5 py-5 lg:py-7.5">
                        {false && <>
                            {/* 
                            {book && <>
                                {book.public_data.ipad_templates && <>
                                    <div>
                                        <img src={book.public_data.ipad_templates.portrait_url} alt="Portrait template" className="w-full h-auto" />
                                    </div>
                                </>}
                            </>}
                            */}
                        </>}
                        <div className="flex flex-col gap-4">
                            <div>
                                <label
                                    htmlFor="ipad_name"
                                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                                    {`Select a Service to Create a Book For (required)`}
                                </label>
                                <div className='px-4' style={{ height: 200 }}>
                                    <Select
                                        name="service_unique_id"
                                        required
                                        options={services.map((service) => ({
                                            value: service.unique_identifier,
                                            label: service.public_data.deceased_person.full_name
                                        }))}
                                    />
                                </div>
                                {false && <div className="text-sm text-gray-500 dark:text-gray-400 mt-4">
                                    e.g. narthex, back chapel, viewing room, etc.
                                </div>}
                            </div>
                        </div>
                    </div>
                    <div className="card-footer py-3.5 flex flex-col lg:flex-row items-center justify-between">
                        <div>
                            {errorSavingBook && <div className="text-red-500 text-sm font-medium">{errorSavingBook}</div>}
                            {successSavingBook && <div className="text-green-500 text-sm font-medium">{successSavingBook}</div>}
                        </div>
                        <div>
                            {book ? <button
                                type="submit"
                                className="btn btn-sm btn-primary"
                                disabled={savingBook}
                            >
                                {!savingBook ? `Update Book` : `Updating Book...`}
                            </button> : <button
                                type="submit"
                                className="btn btn-sm btn-primary"
                                disabled={savingBook}
                            >
                                {!savingBook ? `Create Book` : `Creating Book...`}
                            </button>}
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
}